import React, { useEffect, useState } from "react";

const API_URL_POPUP = `${process.env.REACT_APP_API_BASE_URL}/accounts/auth/popup`;
function MainServicePopup() {
  const [status, setStatus] = useState("Authorizing...");

  useEffect(() => {
    async function authorize() {
      try {
        // Get access token from localStorage (on main service domain)
        const accessToken = localStorage.getItem("access_token");
        if (!accessToken) {
          setStatus(
            "No access token found. Please log in on the main service."
          );
          window.opener?.postMessage({ error: "No access token found" }, "*");
          return;
        }
        // Call main service API to get encoded user_id
        const response = await fetch(API_URL_POPUP, {
          method: "POST",
          headers: { Authorization: "Bearer " + accessToken },
        });
        const data = await response.json();
        if (data.encoded_user_id) {
          setStatus("Success! Sending data...");
          window.opener?.postMessage(
            { encoded_user_id: data.encoded_user_id },
            "*"
          );
          setTimeout(() => window.close(), 500);
        } else {
          setStatus(data.detail || "Failed to get encoded user id");
          window.opener?.postMessage(
            { error: data.detail || "Failed to get encoded user id" },
            "*"
          );
        }
      } catch (err) {
        setStatus("Network error");
        window.opener?.postMessage({ error: "Network error" }, "*");
      }
    }
    authorize();
  }, []);

  return (
    <div style={{ padding: 32, textAlign: "center" }}>
      <h3>Main Service Authorization</h3>
      <div>{status}</div>
    </div>
  );
}

export default MainServicePopup;
